




















import Vue from 'vue';
import upgradeVuex from '../vuex/common';
import accountClient from '../../account/apis';

export default Vue.extend({
  mixins: [upgradeVuex],
  data() {
    return {
      userTotal: 0,
    };
  },
  methods: {
    getUserTotal() {
      accountClient.getUserTotal({}).success((r) => {
        this.userTotal = r;
      });
    },
  },
  mounted() {
    this.getUserTotal();
  },
});
